import { render, staticRenderFns } from "./ReportsTable.vue?vue&type=template&id=5d952b6d&scoped=true&"
import script from "./ReportsTable.vue?vue&type=script&lang=ts&"
export * from "./ReportsTable.vue?vue&type=script&lang=ts&"
import style0 from "./ReportsTable.vue?vue&type=style&index=0&id=5d952b6d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d952b6d",
  null
  
)

export default component.exports